<nav
  *ngIf="isVisible"
  class="flex flex-wrap justify-center items-center bg-white max-w-[978px]"
  aria-label="Pagination"
>
  <!-- Previous page button -->
  <button
    class="flex justify-center items-center self-stretch p-2 my-auto w-10 min-h-10"
    aria-label="Previous page"
    [disabled]="currentPage === 1"
    [class.opacity-50]="currentPage === 1"
    [class.cursor-not-allowed]="currentPage === 1"
    (click)="onPageChange(currentPage - 1)"
  >
    <img
      [src]="leftArrowSrc"
      class="object-contain self-stretch my-auto w-6 aspect-square"
      alt="Previous page"
    />
  </button>

  <!-- Page numbers -->
  <ng-container *ngFor="let page of visiblePages">
    <ng-container *ngIf="page !== '...'">
      <button
        [class]="page === currentPage ? activeClasses : inactiveClasses"
        [attr.aria-current]="page === currentPage ? 'page' : null"
        [attr.aria-label]="'Page ' + page"
        (click)="handlePageClick(page)"
      >
        <span class="self-stretch px-2 my-auto">
          {{ page }}
        </span>
      </button>
    </ng-container>

    <div
      *ngIf="page === '...'"
      class="flex justify-center items-center self-stretch p-2 my-auto text-base font-medium text-black whitespace-nowrap min-h-10"
    >
      <span class="self-stretch px-2 my-auto">...</span>
    </div>
  </ng-container>

  <!-- Next page button -->
  <button
    class="flex justify-center items-center self-stretch p-2 my-auto w-10 min-h-10"
    aria-label="Next page"
    [disabled]="currentPage === totalPages"
    [class.opacity-50]="currentPage === totalPages"
    [class.cursor-not-allowed]="currentPage === totalPages"
    (click)="onPageChange(currentPage + 1)"
  >
    <img
      [src]="rightArrowSrc"
      class="object-contain self-stretch my-auto w-6 aspect-square"
      alt="Next page"
    />
  </button>
</nav>
